import * as _ from 'lodash';
import * as utils from '../utils';
import * as analytics from '../commons/testimAnalytics';
import * as servicesApi from '../commons/testimServicesApi';
import { ArgError } from '../errors';
import { CLI_MODE } from '../commons/constants';
import type { RunnerOptions } from 'src/runOptions';
import type { ExecutionList } from './TestPlanRunner';
import type { RunListResult } from 'services/src/suite/service';
import type { TestWithCustomTestDataAndRunConfig } from 'services/src/commons/testListBuilder';

interface LightweightOnlyTestIdsTest { testId: string; testConfig: {}; resultId: string }
interface LightweightOnlyTestIdsSuite { tests: LightweightOnlyTestIdsTest[][] }

export const extensionBrowsers = ['edge-chromium', 'chrome'];
export const seleniumBrowsers = [...extensionBrowsers, 'firefox', 'safari', 'safari technology preview'];
type ExtensionBrowsers = typeof extensionBrowsers[number];
type SeleniumBrowsers = typeof seleniumBrowsers[number];
export type BrowserType = ExtensionBrowsers | SeleniumBrowsers;
export type RunnerMode = typeof CLI_MODE[keyof typeof CLI_MODE];

export async function getSuite(options: RunnerOptions, branchToUse: string): Promise<LightweightOnlyTestIdsSuite | RunListResult> {
    if (options.lightweightMode?.onlyTestIdsNoSuite && options.testId) {
        const tests = [options.testId.map<LightweightOnlyTestIdsTest>(testId => ({ testId, testConfig: {}, resultId: utils.guid() }))];
        return { tests };
    }
    return await servicesApi.getSuiteTestList({
        projectId: options.project,
        labels: options.label,
        testIds: options.testId,
        testNames: options.name,
        testConfigNames: options.testConfigNames,
        suiteNames: options.suites,
        suiteIds: options.suiteIds,
        branch: branchToUse,
        rerunFailedByRunId: options.rerunFailedByRunId,
        testConfigIds: options.testConfigIds,
        intersections: options.intersections,
    });
}


export function calcTestResultStatus(tests: { [testResultId: string]: { success: boolean } }) {
    const total = Object.keys(tests).length;
    const passed = Object.keys(tests).reduce((count, resultId) => count + (tests[resultId].success === true ? 1 : 0), 0);
    return total === passed;
}


export async function validateConfig(options: RunnerOptions, testList: ExecutionList) {
    //TODO resolve naive implementation for testList.
    const supportedBrowsers = options.mode === CLI_MODE.EXTENSION ? extensionBrowsers : seleniumBrowsers;
    const diff = _.difference(utils.getUniqBrowsers(options, testList as TestWithCustomTestDataAndRunConfig[]), supportedBrowsers);

    if (diff.length > 0) {
        analytics.trackWithCIUser('invalid-config-run', {
            browser: diff.join(', '),
            mode: 'runner',
        });
        throw new ArgError(`browser type <${diff}> is not supported in ${options.mode} mode.`);
    }

    return testList;
}
